import { Service } from '../entities/service';
import { BankNote } from 'src/app/assabil-kernel/models/entities/control-tables/bank-note';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';

export class SettlementValidationRquest extends BaseRequest {
	
	services 		: Service[];
	bankNotes 		: BankNote[];
	cashAmount 		: number;
	nonCashAmount 	: number;

}